import { TEMPLATE_REFERENCE_TYPES } from './whatsappSIdebarTabs';

/**
 * Aliases legados aceitos pelo POST /v1/queue/whatsapp-send/batch.
 * O backend valida `template` contra uma whitelist de aliases: nem o `name` do
 * template na Meta nem o `reference` ("Tipo no sistema") passam por ela. Como a
 * escolha do usuário vem pelo `reference`, é aqui que traduzimos.
 */
export const TEMPLATE_REFERENCE_TO_ALIAS = {
	PROPOSTA                : 'template_proposta',
	PROPOSTA_ATIVO          : 'template_proposal_active',
	// O backend tem também `template_interesse_active`, que resolve para o mesmo
	// reference INTERESSE, então o alias abaixo cobre os dois.
	INTERESSE               : 'template_interesse',
	COBRANCA_MINUTA_ENVIO_1 : 'template_cobrar_minuta',
	ENVIO_MANUAL            : 'template_envio_manual',
};

/**
 * Tipo dos templates enviados avulsos pelo detalhe do caso: vários templates podem
 * tê-lo, e o backend envia o escolhido pelo `templateId` (AFCO-528).
 */
export const MANUAL_SEND_REFERENCE = 'ENVIO_MANUAL';

const REFERENCE_LABELS = TEMPLATE_REFERENCE_TYPES.reduce( ( labels, type ) => {
	labels[ type.value ] = type.label;
	return labels;
}, {} );

const REFERENCE_ORDER = TEMPLATE_REFERENCE_TYPES.map( type => type.value );

export const getTemplateAlias = ( reference ) => TEMPLATE_REFERENCE_TO_ALIAS[ reference ];

/** Mesmo texto que o operador escolheu em "Tipo no sistema" (Saúde do WhatsApp). */
export const getReferenceLabel = ( reference ) => REFERENCE_LABELS[ reference ] ?? reference;

/**
 * O sync do backend grava `reference = name` nos templates que ainda não foram
 * mapeados, então essa igualdade é o sinal de "sem Tipo no sistema".
 */
export const isTemplateMapped = ( template ) => !!template
	&& template.reference !== template.name
	&& !!getTemplateAlias( template.reference );

/**
 * Templates que podem ser disparados: primeiro um por tipo, na ordem de
 * TEMPLATE_REFERENCE_TYPES; depois cada template "Envio manual", pelo nome da Meta.
 *
 * Dois templates da Meta podem apontar para o mesmo tipo; como o alias enviado seria
 * idêntico, mantemos só o primeiro para não oferecer duas opções que fazem exatamente
 * a mesma coisa. Os de "Envio manual" não colapsam: cada um vai com o próprio
 * `templateId`, e escolher entre eles é justamente o objetivo do tipo.
 */
export const toSendableTemplates = ( templates = [] ) => {
	const byReference = new Map();
	const manualSend = [];

	templates.filter( isTemplateMapped ).forEach( template => {
		if ( template.reference === MANUAL_SEND_REFERENCE ) {
			manualSend.push( {
				...template,
				key          : `template-${template.id}`,
				alias        : getTemplateAlias( template.reference ),
				label        : template.name,
				templateId   : template.id,
				isManualSend : true,
			} );
			return;
		}
		if ( !byReference.has( template.reference ) ) {
			byReference.set( template.reference, {
				...template,
				key   : template.reference,
				alias : getTemplateAlias( template.reference ),
				label : getReferenceLabel( template.reference ),
			} );
		}
	} );

	const byType = REFERENCE_ORDER
		.filter( reference => byReference.has( reference ) )
		.map( reference => byReference.get( reference ) );

	return [
		...byType,
		...manualSend.sort( ( a, b ) => a.name.localeCompare( b.name ) ),
	];
};
